import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

/**
 * Compact Upgrade chip that lives next to a page title during the free trial.
 * Hidden for grandfathered / active subscribers — only shows when the user
 * is actively trialing so it never nags paying customers.
 */
export default function TrialUpgradeChip() {
  const { user } = useAuth();
  const b = user?.billing;
  if (!b || b.plan !== "trial" || !b.is_active) return null;
  const days = b.days_left ?? 0;
  return (
    <Link
      to="/billing"
      data-testid="trial-upgrade-chip"
      title={`${days} day${days === 1 ? "" : "s"} left on your free trial`}
      className="inline-flex items-center gap-1.5 bg-amber-500/15 hover:bg-amber-500/25 border border-amber-500/50 text-amber-200 text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full transition-colors align-middle"
    >
      <Sparkles size={12} />
      Upgrade
      <span className="text-amber-300/70 font-normal normal-case">· {days}d left</span>
    </Link>
  );
}
